import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LayoutComponent} from './layout.component';
import {MenuItemComponent} from './menu-item/menu-item.component';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {UIRoutes} from '../../app.routing';
import {AlertModule} from '../../sdk/component/alert/alert.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgOptimizedImage} from '@angular/common';
import {AssetPipeModule} from '../../sdk/pipe/assetPipeModule';
import {Select} from 'primeng/select';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {MenuModule} from 'primeng/menu';
import {AvatarModule} from 'primeng/avatar';
import {Tooltip} from 'primeng/tooltip';

@NgModule({
    imports: [
        BrowserModule, ReactiveFormsModule, UIRoutes, AlertModule, NgbModule, NgOptimizedImage, AssetPipeModule,
        Select, FormsModule, NgxUiLoaderModule, MenuModule, AvatarModule, Tooltip
    ],
    exports: [LayoutComponent],
    declarations: [LayoutComponent, MenuItemComponent],
    providers: [AuthenticationService],
})

export class LayoutModule
{
}